export const langs = [ // DEPRECATED
    {
        id: 'en',
        label: 'English'
    },
    {
        id: 'pl',
        label: 'Polski'
    },
    {
        id: 'cs',
        label: 'Čeština'
    }
]